import cx from 'classnames'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './TooltipIcon.css'
import Popover from '../Popover'

const TooltipIcon = props => {
  const {
    className,
    iconType = 'ec-information-fill',
    tooltipTitle
  } = props

  const clz = cx(
    styles.TooltipIcon,
    { [className]: !!className }
  )

  return (
    <Popover
      content={tooltipTitle}
      className={clz}
    >
      <Icon
        name={iconType}
        align='sub'
        color='#979ba7'
        size={17}
      />
    </Popover>
  )
}

export default TooltipIcon
